import React, { useEffect, useState } from "react";

import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AlertMessage from "../include/AlertMessage";

var _ = require("lodash");

function AddAgent() {
    const { role, user } = useAuth();

    const [alert, setAlert] = useState({
        type: "",
        message: ""
    });

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        artists: []
    });

    const [errors, setErrors] = useState({});
    const [allArtists, setArtists] = useState([]);
    const [loading, setLoading] = useState(true);

    const redirectHistory = useNavigate();

    const token = sessionStorage.getItem("JWT_TOKEN");

    const fetchAllArtists = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/artists`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token
                    }
                }
            );

            const artistdata = response.data.documents;
            console.log("Fetched artists:", artistdata); // Debugging line

            if (Array.isArray(artistdata) && artistdata.length > 0) {
                setArtists(artistdata);
            } else {
                setArtists([]);
            }
        } catch (err) {
            const apierror = _.get(
                err,
                ["response", "data", "error", "message"],
                "Something went wrong"
            );

            setAlert({
                type: "error",
                message: apierror
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.documentElement.className = "";
        fetchAllArtists();
    }, []);

    /**
     * Handle artist checkbox selection
     */
    const handleArtistChange = (artistId) => {
        setFormData((prev) => {
            const alreadySelected = prev.artists.includes(artistId);

            if (alreadySelected) {
                return {
                    ...prev,
                    artists: prev.artists.filter(
                        (id) => id !== artistId
                    )
                };
            }

            return {
                ...prev,
                artists: [...prev.artists, artistId]
            };
        });

        // Remove artist error after selecting
        setErrors((prev) => ({
            ...prev,
            artists: ""
        }));
    };

    const validate = () => {
        const newErrors = {};

        if (!formData.firstName.trim()) {
            newErrors.firstName = "First Name is required.";
        }

        if (!formData.lastName.trim()) {
            newErrors.lastName = "Last Name is required.";
        }

        if (formData.artists.length === 0) {
            newErrors.artists = "Please select at least one artist.";
        }

        return newErrors;
    };

    const handleAdd = async (e) => {
        e.preventDefault();

        const newErrors = validate();

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            setLoading(true);

            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL}/addagent`,
                    {
                        artists: formData.artists,
                        firstName: formData.firstName,
                        lastName: formData.lastName
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + token
                        }
                    }
                );

                if (
                    response.status === 200 ||
                    response.status === 201
                ) {
                    setAlert({
                        type: "success",
                        message: "Agent added successfully!"
                    });

                    setTimeout(() => {
                        redirectHistory("/agents");
                    }, 2500);
                }
            } catch (err) {
                const apierror = _.get(
                    err,
                    ["response", "data", "error", "message"],
                    "Failed to add agent. Please try again"
                );

                setAlert({
                    type: "error",
                    message: apierror
                });
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li>
                            <Link
                                to="/dashboard"
                                className="btn btn-primary"
                            >
                                Dashboard
                            </Link>
                        </li>

                        <li>
                            <Link
                                to="/agents"
                                className="btn btn-primary"
                            >
                                Agents
                            </Link>
                        </li>

                        <li>Add</li>
                    </ul>
                </div>
            </div>

            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon">
                                    <i className="mdi mdi-account-plus"></i>
                                </span>
                                Add Agent
                            </p>
                        </header>

                        <div className="card-content">
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>
                            ) : (
                                <form onSubmit={handleAdd}>
                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() =>
                                                setAlert({
                                                    type: "",
                                                    message: ""
                                                })
                                            }
                                        />
                                    )}

                                    {/* FIRST NAME / LAST NAME */}
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">
                                                First Name{" "}
                                                <span style={{ color: "red" }}>
                                                    *
                                                </span>
                                            </label>

                                            <div className="control">
                                                <input
                                                    className="input"
                                                    id="firstName"
                                                    type="text"
                                                    placeholder="First Name"
                                                    value={
                                                        formData.firstName
                                                    }
                                                    onChange={(e) =>
                                                        setFormData({
                                                            ...formData,
                                                            firstName:
                                                                e.target.value
                                                        })
                                                    }
                                                />
                                            </div>

                                            {errors.firstName && (
                                                <p
                                                    className="help"
                                                    style={{ color: "red" }}
                                                >
                                                    {errors.firstName}
                                                </p>
                                            )}
                                        </div>

                                        <div className="field">
                                            <label className="label">
                                                Last Name{" "}
                                                <span style={{ color: "red" }}>
                                                    *
                                                </span>
                                            </label>

                                            <div className="control">
                                                <input
                                                    className="input"
                                                    id="lastName"
                                                    type="text"
                                                    placeholder="Last Name"
                                                    value={
                                                        formData.lastName
                                                    }
                                                    onChange={(e) =>
                                                        setFormData({
                                                            ...formData,
                                                            lastName:
                                                                e.target.value
                                                        })
                                                    }
                                                />
                                            </div>

                                            {errors.lastName && (
                                                <p
                                                    className="help"
                                                    style={{ color: "red" }}
                                                >
                                                    {errors.lastName}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    {/* ARTISTS CARD */}
                                    <div className="card mt-6">
                                        <header className="card-header">
                                            <p className="card-header-title">
                                                <span className="icon">
                                                    <i className="mdi mdi-account-music"></i>
                                                </span>
                                                Select Artists
                                            </p>
                                        </header>

                                        <div className="card-content">
                                            {allArtists.length === 0 ? (
                                                <p>
                                                    No artists available.
                                                </p>
                                            ) : (
                                                <>
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                                                        {allArtists.map(
                                                            (artist) => (
                                                                <label
                                                                    key={
                                                                        artist.$id
                                                                    }
                                                                    className="flex items-center gap-3 cursor-pointer"
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        value={
                                                                            artist.$id
                                                                        }
                                                                        checked={formData.artists.includes(
                                                                            artist.$id
                                                                        )}
                                                                        onChange={() =>
                                                                            handleArtistChange(
                                                                                artist.$id
                                                                            )
                                                                        }
                                                                    />

                                                                    <span>
                                                                        {
                                                                            artist.firstName
                                                                        }{" "}
                                                                        {
                                                                            artist.lastName
                                                                        }
                                                                    </span>
                                                                </label>
                                                            )
                                                        )}
                                                    </div>

                                                    {errors.artists && (
                                                        <p
                                                            className="help mt-3"
                                                            style={{
                                                                color: "red"
                                                            }}
                                                        >
                                                            {errors.artists}
                                                        </p>
                                                    )}

                                                    {/* Selected artists count */}
                                                    {formData.artists.length >
                                                        0 && (
                                                            <p className="mt-4">
                                                                <strong>
                                                                    {
                                                                        formData
                                                                            .artists
                                                                            .length
                                                                    }
                                                                </strong>{" "}
                                                                artist
                                                                {formData.artists
                                                                    .length > 1
                                                                    ? "s"
                                                                    : ""}{" "}
                                                                selected
                                                            </p>
                                                        )}
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    {/* SUBMIT */}
                                    <div className="flex justify-center items-center mt-6">
                                        <div className="field grouped">
                                            <div className="control">
                                                <button
                                                    type="submit"
                                                    className="button green"
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AddAgent;